(function(){
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pcard-atc-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    // Visual feedback
    btn.disabled = true;
    var svgOriginal = btn.innerHTML;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:1.7rem;height:1.7rem"><polyline points="20 6 9 17 4 12"/></svg>';

    // Gather sections to re-render (cart drawer needs its section)
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: sectionsToBundle })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      // Fire cart:refresh so the cart drawer updates and opens
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));

      // Also fire the theme's pubsub cart update if available
      if (window.FoxTheme && FoxTheme.pubsub && data.sections) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: data });
      }

      setTimeout(function() {
        btn.disabled = false;
        btn.innerHTML = svgOriginal;
      }, 2000);
    })
    .catch(function() {
      btn.disabled = false;
      btn.innerHTML = svgOriginal;
    });
  });
})();
